import { Injectable } from '@angular/core';
import { RecommendationType } from '../dto/recommendation-type';
import { BoolDto } from '../../../common/dto/bool-dto';

@Injectable({
  providedIn: 'root'
})
export class RecommendationPropertiesService {

  constructor() { }

  getAllRecommendationTypes(): RecommendationType[] {
    let types = [
      { id: 1, name: 'A', description: 'Level A recommendation' },
      { id: 2, name: 'B', description: 'Level B recommendation' },
      { id: 3, name: 'C', description: 'Level C recommendation' },

    ]
    return types;
  }

  getRecommendationType(list: RecommendationType[], id?: number): RecommendationType {
    for (let element of list) {
      if (id === element.id) {
        return element;
      }
    }
    return { id: 0, name: 'N/A', description: '' }
  }

  getAllRecommendationClosedStates(): BoolDto[] {
    let states = [
      { state: true, expression: 'Yes' },
      { state: false, expression: 'No' },
    ]
    return states;
  }

  getRecommendationClosedState(list: BoolDto[], state?: boolean): BoolDto {
    for(let element of list) {
      if (state === element.state) {
        return element;
      }
    }
    return {state: false, expression: 'N/A'};
  }

}
